import { render, staticRenderFns } from "./DevolucionDespachoFormComponent.vue?vue&type=template&id=846bb7e8&"
import script from "./DevolucionDespachoFormComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionDespachoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports